import { DataTypeEnum } from "../_common/enum/dataType.enum";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "dropdown";

export const dropdownService = {
    fetchData
};

function fetchData(dataTypeEnum: DataTypeEnum, parentId?: number, method: string = 'GET') {
    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataTypeEnum}`;

    const url = `${API_URL}/${API_NAME}/${endpoint}/?parentId=${parentId || ""}`;

    return fetch(url, requestOptions).then(handleResponse);
}



